import React from "react";
import { Box, Grid, Typography, IconButton, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Link } from "react-router-dom";

const Footer = ({ activeLink, setActiveLink }) => {
  // Update activeLink when a footer link is clicked
  const handleLinkClick = (link) => {
    setActiveLink(link);  // Update the active link when a footer link is clicked
  };
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        marginTop: "20px",
        marginBottom: { md: "0px" },
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column", // Ensure vertical stacking on smaller screens
          justifyContent: "center", // Center content vertically
          alignItems: "center",
          padding: "20px",
          maxWidth: "1200px", // Set the max width
          margin: "0 auto",
        }}>
        <Grid container spacing={4} alignItems="flex-start">
          {/* Column 1 */}
          <Grid item xs={6} sm={6} md={3}>
            <Typography
              variant="h4"
              gutterBottom
              sx={{ color: "white", fontWeight: "700" }}>
              SAVA
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body" gutterBottom sx={{ color: "white" }}>
                info@sava.co.tz
              </Typography>
              <Typography variant="body" gutterBottom sx={{ color: "white" }}>
                +255 672 600 151
              </Typography>
            </Box>

            {/*     <img
              alt="logo"
              src={logo}
              style={{ height: "90px", width: "90px", marginTop: "20px" }}
            /> */}
          </Grid>

          {/* Column 2 */}
          <Grid item xs={6} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ color: "white" }}>
              Quick Links
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: { xs: "20px", md: "5px" },
              }}>


              <Link
                to="/home"
                onClick={() => handleLinkClick("/home")}
                style={{
                  textDecoration: activeLink === "/home" ? "underline" : "none",
                  textDecorationColor: activeLink === "/home" ? "white" : "transparent",
               
                }}>
                <Typography variant="body" gutterBottom sx={{ color: "white"}}>
                  Home
                </Typography>
              </Link>


              <Link
                to="/ambassador"
                onClick={() => handleLinkClick("/ambassador")}

                style={{
                  textDecoration: activeLink === "/ambassador" ? "underline" : "none",
                  textDecorationColor: activeLink === "/ambassador" ? "white" : "transparent",
                }}>
                <Typography variant="body" gutterBottom sx={{ color: "white" }}>
                  Ambassador
                </Typography>
              </Link>

              <Link 
              to="/careers"
              onClick={() => handleLinkClick("/careers")} 
              style={{ 
                textDecoration: activeLink === "/careers" ? "underline" : "none",
                textDecorationColor: activeLink === "/careers" ? "white" : "transparent",
                }}>
                <Typography variant="body" gutterBottom sx={{ color: "white" }}>
                  Careers
                </Typography>
              </Link>
            </Box>
          </Grid>

          {/* Column 3 */}
          <Grid item xs={6} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ color: "white" }}>
              Help & Support
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: { xs: "20px", md: "5px" },
              }}>
              <Link to="/faq" 
              onClick={() => handleLinkClick("/faq")} 
              style={{ 
                textDecoration: activeLink === "/faq" ? "underline" : "none",
                textDecorationColor: activeLink === "/faq" ? "white" : "transparent", 
                }}>
                <Typography variant="body" gutterBottom sx={{ color: "white" }}>
                  FAQ
                </Typography>
              </Link>

              <Link to="/contact" 
              onClick={() => handleLinkClick("/contact")} 
              style={{ textDecoration: activeLink === "/contact" ? "underline" : "none",
                textDecorationColor: activeLink === "/contact" ? "white" : "transparent",  }}>
                <Typography
                  variant="body"
                  gutterBottom
                  sx={{ color: "white", marginTop: "2px" }}>
                  Contact
                </Typography>
              </Link>

              <Link to="/privacy-policy"
              onClick={() => handleLinkClick("/privacy-policy")} 
               style={{ textDecoration: activeLink === "/privacy-policy" ? "underline" : "none",
                textDecorationColor: activeLink === "/privacy-policy" ? "white" : "transparent",   }}>
                <Typography
                  variant="body"
                  gutterBottom
                  sx={{ color: "white", marginTop: "2px" }}>
                  Privacy Policy
                </Typography>
              </Link>

              <Link to="/terms-of-use" 
              onClick={() => handleLinkClick("/terms-of-use")} 
              style={{ textDecoration: activeLink === "/terms-of-use" ? "underline" : "none",
                textDecorationColor: activeLink === "/terms-of-use" ? "white" : "transparent", }}>
                <Typography
                  variant="body"
                  gutterBottom
                  sx={{ color: "white", marginTop: "2px" }}>
                  Terms of use
                </Typography>
              </Link>
            </Box>
          </Grid>

          {/* Column 4 */}
          <Grid item xs={6} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ color: "white" }}>
              Our Address
            </Typography>
            <Box>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body" gutterBottom sx={{ color: "white" }}>
                  Mikocheni B,
                </Typography>
                <Typography variant="body" gutterBottom sx={{ color: "white" }}>
                  Coca cola Road
                </Typography>
                <Typography variant="body" gutterBottom sx={{ color: "white" }}>
                  Auditax House 1st Floor
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex" }}>
              <IconButton>
                <a
                  href="https://www.instagram.com/sava_loan?igsh=cTFjNHh0aDhteGVs"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}>
                  <LinkedInIcon sx={{ color: "white" }} />
                </a>
              </IconButton>

              <IconButton sx={{ color: "white" }}>
                <a
                  href="https://www.instagram.com/sava_loan?igsh=cTFjNHh0aDhteGVs"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}>
                  <InstagramIcon />
                </a>
              </IconButton>

              <IconButton sx={{ color: "white" }}>
                <a
                  href="https://www.facebook.com/share/193aYRi3Vt/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}>
                  <FacebookIcon />
                </a>
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          height: "50px",
          alignItems: "center",
        }}>
        <Divider />
        <Typography sx={{ color: "white" }}>
          ©2025 SAVA Tech Financial Services
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
